export default __webpack_public_path__ + "static/media/misc-books4-480w.978fc6e6.webp";